module.exports = __webpack_public_path__ + "static/media/NotiDropdownUp.f0a35c03.svg";